import { sendTracking } from './sendTracking';
import { storage, path } from '@commons';

import { MODULE_FUNCTIONALITY_ENUM } from '@handler/tracking/moduleLog/moduleFunctionalityEnum';
import { MODULE_ACTIONS_ENUM } from './moduleActionEnum';

export const trackingEventCX = (type, funcionalidade) => {
  const configSession = JSON.parse(storage.get('CONFIG_SESSION'));
  const { contaAgrare } = configSession;

  const user = JSON.parse(storage.get(path.sessionUser));
  const isTrackingBlockedUser =
    user?.perfil === 'ESTUDANTE_PESQUISA' || user?.perfil === 'SUPORTE_AGRARE';
  const trackingEnabled = contaAgrare?.trackingEnabled;

  if (!trackingEnabled || isTrackingBlockedUser) return;

  const enumBase =
    type === 'screen' ? MODULE_FUNCTIONALITY_ENUM : MODULE_ACTIONS_ENUM;

  const eventInfo =
    typeof funcionalidade === 'string'
      ? enumBase[funcionalidade]
      : funcionalidade;

  if (!eventInfo) {
    return;
  }

  const isFarm = eventInfo.id === 'FAZENDAS_ENTRAR';
  const farmName = isFarm ? contaAgrare?.accountName : null;

  sendTracking({
    email: user?.email,
    external_id_client: contaAgrare?.accountCode,
    extraData: {
      id: eventInfo.id,
      perfil: user?.perfil,
      fazendaNome: farmName,
    },
    identifier: eventInfo.descricao,
    type_tracking: type,
  });
};
